<template>
  <el-cascader
    class="width-max"
    :value="cascaderValue"
    :options="chinaAreaData"
    :props="{ multiple: true, checkStrictly: true }"
    filterable
    clearable
    :placeholder="placeholder"
    @input="onInput">
  </el-cascader>
</template>

<script>
/** 省市区多选；v-model 为 ["1","1,2","1,2,3"] */
export default {
  name: 'ContainmentAreaCascader',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
  },
  data () {
    return {
      chinaAreaData: [],
    }
  },
  computed: {
    cascaderValue () {
      return (this.value || [])
        .map(s => String(s).split(',').map(Number).filter(n => !Number.isNaN(n)))
        .filter(p => p.length)
    },
  },
  created () {
    request.alert('queryAllFormatted').then(({ data }) => {
      this.chinaAreaData = Array.isArray(data) ? data : (Array.isArray(data && data.data) ? data.data : [])
    }).catch(() => {
      this.chinaAreaData = []
    })
  },
  methods: {
    onInput (paths) {
      const next = (paths || []).map(p => p.join(','))
      this.$emit('input', next)
      this.$emit('change', next)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/area/components/ContainmentAreaCascader.vue